import React, { Component } from "react";
import { Select, Spin, Empty, Tag } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import { ModalItem, ButtonItem } from "./Items";
import { DeleteOutlined } from "@ant-design/icons";

const { Option } = Select;

// Buscador multiple de insumos para cargar varios renglones de golpe.
//
// NO usa SelectInsumosItem a proposito. Ese componente colapsa `opciones` al elegir
// (SelectInsumosItem.js:255-258), asi que en modo multiple los tags ya elegidos pierden
// su etiqueta en cuanto una busqueda posterior reemplaza las opciones, y se re-pintan
// como el ObjectId pelon. Arreglarlo alla implicaria tocar un componente importado por
// ~92 archivos. Aqui `labelInValue` guarda la etiqueta dentro del propio valor, asi que
// el problema no existe, y ademas se conserva el objeto insumo completo (con precios[])
// que la pantalla necesita para precargar el renglon.
class ModalSeleccionMultipleInsumos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      seleccionados: [],
      cargando: false,
      hayMas: true,
      texto: "",
    };
    this.buscar = debounce(this.buscar.bind(this), 300);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ opciones: [], seleccionados: [], texto: "", hayMas: true }, () => this.consultar("", false));
    }
  }

  buscar(texto) {
    this.setState({ texto, hayMas: true });
    this.consultar(texto, false);
  }

  consultar(texto, agregar) {
    this.setState({ cargando: true });
    const skip = agregar ? this.state.opciones.length : 0;
    axios
      .post(
        "insumos/selectInsumosItemVentaFuncion",
        {
          empresaId: this.props.empresaId,
          query: texto,
          skip,
          excluirIds: this.props.excluirIds || [],
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const recibidos = Array.isArray(res.data) ? res.data : res.data?.insumos || [];
        this.setState((prev) => ({
          opciones: agregar ? [...prev.opciones, ...recibidos] : recibidos,
          cargando: false,
          hayMas: recibidos.length > 0,
        }));
      })
      .catch(() => this.setState({ cargando: false, hayMas: false }));
  }

  onPopupScroll = (e) => {
    const { target } = e;
    if (!this.state.cargando && this.state.hayMas && target.scrollTop + target.offsetHeight >= target.scrollHeight - 20) {
      this.consultar(this.state.texto, true);
    }
  };

  // antd entrega [{value, label}]; el objeto insumo completo se recupera de `opciones`
  // en el momento de elegirlo y se conserva en `seleccionados` aunque despues se
  // busque otra cosa
  onChange = (valores) => {
    const porId = new Map(this.state.seleccionados.map((insumo) => [String(insumo._id), insumo]));
    const nuevos = (valores || []).map((valor) => {
      const id = String(valor.value);
      if (porId.has(id)) return porId.get(id);
      const enOpciones = this.state.opciones.find((insumo) => String(insumo._id) === id);
      // El fallback no deberia ocurrir (solo se puede elegir lo que esta en pantalla),
      // pero si ocurriera el renglon nace sin precio en vez de romperse
      return enOpciones || { _id: id, stringBuscar: valor.label, descripcion: valor.label };
    });
    this.setState({ seleccionados: nuevos });
  };

  quitar(id) {
    this.setState((prev) => ({
      seleccionados: prev.seleccionados.filter((insumo) => String(insumo._id) !== String(id)),
    }));
  }

  aceptar = () => {
    const { seleccionados } = this.state;
    if (seleccionados.length === 0) return;
    this.props.onAceptar(seleccionados);
    this.setState({ opciones: [], seleccionados: [], texto: "" });
  };

  render() {
    const { visible, onCancelar } = this.props;
    const { opciones, seleccionados, cargando } = this.state;

    return (
      <ModalItem
        title="Agregar varios insumos"
        visible={visible}
        onCancel={onCancelar}
        spinning={false}
        footer={null}
        width={700}
      >
        <p style={{ color: "#888", marginBottom: 8 }}>
          Busca y elige todos los insumos que quieras. Puedes hacer varias búsquedas: lo que ya
          elegiste se conserva abajo.
        </p>

        <Select
          mode="multiple"
          labelInValue
          showSearch
          filterOption={false}
          style={{ width: "100%" }}
          placeholder="Buscar insumo por clave o descripción"
          notFoundContent={cargando ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin resultados" />}
          value={seleccionados.map((insumo) => ({ value: String(insumo._id), label: insumo.stringBuscar || insumo.descripcion }))}
          onSearch={this.buscar}
          onChange={this.onChange}
          onPopupScroll={this.onPopupScroll}
          dropdownMatchSelectWidth={600}
        >
          {opciones.map((insumo) => (
            <Option value={String(insumo._id)} key={String(insumo._id)}>
              {insumo.stringBuscar}
            </Option>
          ))}
        </Select>

        {seleccionados.length > 0 && (
          <div style={{ marginTop: 12, maxHeight: 260, overflowY: "auto", border: "1px solid #f0f0f0", borderRadius: 4, padding: 8 }}>
            {seleccionados.map((insumo) => (
              <div key={String(insumo._id)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "2px 0" }}>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {insumo.stringBuscar || insumo.descripcion}
                </span>
                <ButtonItem size="small" danger icon={<DeleteOutlined />} onClick={() => this.quitar(insumo._id)} />
              </div>
            ))}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
          <Tag color={seleccionados.length ? "cyan" : "default"}>{seleccionados.length} seleccionado(s)</Tag>
          <div>
            <ButtonItem style={{ marginRight: 8 }} onClick={onCancelar}>
              Cancelar
            </ButtonItem>
            <ButtonItem type="primary" disabled={seleccionados.length === 0} onClick={this.aceptar}>
              Agregar {seleccionados.length > 0 ? `${seleccionados.length} renglón(es)` : ""}
            </ButtonItem>
          </div>
        </div>
      </ModalItem>
    );
  }
}

export default ModalSeleccionMultipleInsumos;
